import { Component } from '@angular/core';
import { StoreService } from 'src/app/services/store/store.service';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
	readonly parameters$ = this.storeService.initialParameters$;
	constructor(private readonly storeService: StoreService) {}
}
